export const buildRecruiterStudentParentPayload = ({
  messageBody,
  dstId,
  sendToStudent = false,
  sendToParent = false,
  attachmentUrl,
  isInternational = false,
  single = false,
}) => {
  const ids = Array.isArray(dstId) ? dstId.filter(Boolean) : dstId != null ? [dstId] : [];
  const payload = {
    message_body: messageBody,
    dst_id: ids,
  };

  if (sendToStudent && sendToParent) {
    payload.event_type = "recruiter_student";
    payload.parent_ack = true;
  } else if (sendToParent) {
    payload.event_type = "recruiter_parent";
    payload.parent_ack = true;
  } else {
    payload.event_type = "recruiter_student";
  }

  if (isInternational) {
    payload.is_international = true;
    payload.event_type = "international_student";
  }

  if (attachmentUrl) {
    payload.attachment_url = attachmentUrl;
  }

  if (single) {
    payload.single = true;
  }

  return payload;
};

export const hasRecruiterStudentParentSelection = (sendToStudent, sendToParent) =>
  Boolean(sendToStudent || sendToParent);
